
import Vue, { VueConstructor } from "vue"
import ListParagon from "@/components/ListParagon.vue"
import { state } from "@/plugins/state"
import { EventBus } from "@/plugins/eventBus"
import dateFormatMixin from "@/mixins/DateFormatMixin.vue"
import ClientsFormatter from "@/components/workers/ClientsFormatter.vue"
import SendCVDialog from "@/components/workers/SendCVDialog.vue"
import SendSMSDialog from "@/components/workers/SendSMSDialog.vue"
import UpdateAvailabilityDialog from "@/components/workers/UpdateAvailabilityDialog.vue"
import { authPdfDirective } from '@/directives/authPdf'
import { DirectiveBinding } from 'vue/types/options'
import UpdateStateDialog from '@/components/workers/UpdateStateDialog.vue'
import ArchiveDialog from '@/components/workers/ArchiveDialog.vue'
import AddCommentDialog from '@/components/workers/AddCommentDialog.vue'
import ManagePositionsDialog from '@/components/workers/ManagePositionsDialog.vue'
import AvailabilityRequestDialog from '@/components/workers/AvailabilityRequestDialog.vue'
import CardFormatter from '@/components/workers/CardFormatter.vue'
import CommentsFormatter from '@/components/workers/CommentsFormatter.vue'

interface Availability {
  id: number
  status: string,
  date_begin: string,
  date_end: string,
  date_action: string,
  comment?: string
}

interface SMS {
  type: 'MT' | 'MO';
  date_action: string;
  content: string;
}

export default (Vue as VueConstructor<Vue & InstanceType<typeof dateFormatMixin>>).extend({
  name: "WorkerList",
  mixins: [
    dateFormatMixin
  ],
  props: {
    deleted: {
      type: Boolean,
      default: false
    },
    refresh: {
      type: Number,
      default: 0
    }
  },
  components: {
    ListParagon,
    CardFormatter,
    ClientsFormatter,
    CommentsFormatter,
    SendCVDialog,
    SendSMSDialog,
    UpdateAvailabilityDialog,
    UpdateStateDialog,
    AddCommentDialog,
    ArchiveDialog,
    ManagePositionsDialog,
    AvailabilityRequestDialog
  },
  data () {
    return {
      view: "list",
      dialogAvailability: false,
      currentAvailability: {} as Availability,
      adaptTimeData: ':00',
      totalWorkers: 0,
      // show modal
      showSendCV: false,
      showSendSMS: false,
      showAvailabilityDialog: false,
      showUpdateState: false,
      showManagePositions: false,
      showArchive: false,
      showAddComment: false,
      isRemovingPositions: false,
      showAvailabilityRequest: false,
      availabilityDialogMode: 'bulk', // 'bulk' or 'single'
      unitaryWorkerId: null as number | null,
      dialog: false,
      titleModal: "alerts_details",
      data: null,
      modalName: "",
      selected: [] as string[],
      workerTranslation: 'worker',
      headers: [
        {
            text: this.$vuetify.lang.t("$vuetify.card"),
            sortable: true,
            value: 'card'
        },
        {
            text: this.$vuetify.lang.t("$vuetify.favorite_jobs"),
            sortable: true,
            value: 'favorite_jobs',
            sortText: this.$vuetify.lang.t("$vuetify.favorite_jobs_total")
        },
        {
            text: this.$vuetify.lang.t("$vuetify.availabilities"),
            sortable: true,
            value: 'status_updated_at',
            sortText: this.$vuetify.lang.t("$vuetify.status_updated_at")
        },
        {
            text: this.$vuetify.lang.t("$vuetify.recruitment"),
            sortable: true,
            value:'follow_up',
            sortText: this.$vuetify.lang.t("$vuetify.recruitment_total")

        },
        {
            text: this.$vuetify.lang.t("$vuetify.SMS_interaction"),
            sortable: true,
            value: "sms_history",
            width: 250,
            sortText: this.$vuetify.lang.t("$vuetify.SMS_interaction_last_date")
        },
        {
            text: this.$vuetify.lang.t("$vuetify.comments"),
            sortable: true,
            value: "last_comment",
            sortText: this.$vuetify.lang.t("$vuetify.comment_last_date")

        },
      ],
      headersSplitPane: [
        {
          text: this.$vuetify.lang.t("$vuetify.names"),
          sortable: true,
          value: 'names'
        }
      ],
      filters: [
        {label: 'searches', type: 'text-field'},
        {label: 'names', type: 'text-field'},
        {label: 'email', type: 'text-field'},
        {label: 'mobile_phone_number', type: 'text-field'},
        {
          label: 'state',
          type: 'select',
          items:[
            {text: this.$vuetify.lang.t("$vuetify.web"), value: "web"},
            {text: this.$vuetify.lang.t("$vuetify.candidate"), value: "candidate"},
            {text: this.$vuetify.lang.t("$vuetify.employee"), value: "employee"},
            {text: this.$vuetify.lang.t("$vuetify.applicant"), value: "applicant"},
            {text: this.$vuetify.lang.t("$vuetify.pre-registered"), value: "pre-registered"},
            {text: this.$vuetify.lang.t("$vuetify.supplements OK"), value: "supplements OK"}
          ],
          multiple: true
        },
        {
          label: 'status',
          text: this.$vuetify.lang.t("$vuetify.availabilities"),
          type: 'select',
          items:[
            {text: this.$vuetify.lang.t("$vuetify.unavailable"), value: "unavailable"},
            {text: this.$vuetify.lang.t("$vuetify.pending"), value: "pending"},
            {text: this.$vuetify.lang.t("$vuetify.available"), value: "available"},
            {text: this.$vuetify.lang.t("$vuetify.contract"), value: "contract"},
            {text: this.$vuetify.lang.t("$vuetify.unknown"), value: "unknown"}
          ],
          multiple: true
        },
        {label: 'positions', prependValue: 'true:', type: 'autocomplete', url:'/v1/clients/positions', text: 'name', value: 'position_id', search: 'name'},
        {label: 'favorite_jobs', type: 'text-field'},
        {label: 'postal_city_code', type: 'text-field'},
        {
          label: 'transportation_means',
          type: 'select',
          items:[
            {text: this.$vuetify.lang.t("$vuetify.car"), value: "car"},
            {text: this.$vuetify.lang.t("$vuetify.motorbike"), value: "motorbike"},
            {text: this.$vuetify.lang.t("$vuetify.bike_scooter"), value: "bike_scooter"},
            {text: this.$vuetify.lang.t("$vuetify.mass_transit"), value: "mass_transit"},
            {text: this.$vuetify.lang.t("$vuetify.moped"), value: "moped"},
            {text: this.$vuetify.lang.t("$vuetify.walk"), value: "walk"},
            {text: this.$vuetify.lang.t("$vuetify.carpool"), value: "carpool"}
          ],
          multiple: true
        },
        {label: 'comment', type: 'text-field'},
        {label: 'resume_keywords', type: 'text-field'},
        {
          label:'cv',
          type: 'toggle',
          items: [
            {text: this.$vuetify.lang.t("$vuetify.with"), value: true},
            {text: this.$vuetify.lang.t("$vuetify.without"), value: false}
          ]
        },
        {
          label:'active_proposal',
          type: 'toggle',
          items: [
            {text: this.$vuetify.lang.t("$vuetify.with"), value: true},
            {text: this.$vuetify.lang.t("$vuetify.without"), value: false}
          ]
        },
        {label: 'formation_certificate', type: 'text-field'},
        {label: 'equipment', type: 'text-field'},
        {
          label: 'medical_examination',
          type: 'boolean-text-field',
          items: [
            {text: this.$vuetify.lang.t("$vuetify.future"), value: true},
            {text: this.$vuetify.lang.t("$vuetify.passed"), value: false},
          ]
        },
        {
          label: 'is_sms_response',
          type: 'toggle',
          items: [
            {text: this.$vuetify.lang.t("$vuetify.with"), value: true},
            {text: this.$vuetify.lang.t("$vuetify.without"), value: false}
          ]
        },
        {label: 'sms_response', type: 'text-field'},
        {label: 'sms_send', type: 'text-field'},
        {
          label: 'driver_licence',
          type: 'select',
          items:[
            {text: this.$vuetify.lang.t("$vuetify.A1"), value: "A1"},
            {text: this.$vuetify.lang.t("$vuetify.A progressif"), value: "A progressif"},
            {text: this.$vuetify.lang.t("$vuetify.A"), value: "A"},
            {text: this.$vuetify.lang.t("$vuetify.A direct"), value: "A direct"},
            {text: this.$vuetify.lang.t("$vuetify.B"), value: "B"},
            {text: this.$vuetify.lang.t("$vuetify.B1"), value: "B1"},
            {text: this.$vuetify.lang.t("$vuetify.C"), value: "C"},
            {text: this.$vuetify.lang.t("$vuetify.D"), value: "D"},
            {text: this.$vuetify.lang.t("$vuetify.E(B)"), value: "E(B)"},
            {text: this.$vuetify.lang.t("$vuetify.E(C)"), value: "E(C)"},
            {text: this.$vuetify.lang.t("$vuetify.E(D)"), value: "E(D)"}
          ],
          multiple: true
        },
        {
          label: 'has_phone',
          type: 'toggle',
          items: [
            {text: this.$vuetify.lang.t("$vuetify.with"), value: true},
            {text: this.$vuetify.lang.t("$vuetify.without"), value: false}
          ]
        },
        {
          label: 'sex',
          type: 'toggle',
          items: [
            {text: this.$vuetify.lang.t("$vuetify.mister"), value: "M"},
            {text: this.$vuetify.lang.t("$vuetify.misses"), value: "F"}
          ]
        }
      ],
      currentWorkerId: null as number | null,
      updateLoading: false,
      sms: {
        type: 'MT',
        date_action: '',
        content: ''
      } as SMS,
    }
  },
  computed: {
    url: function(): string {
      let agencyParameter = ""
      if (state.agency !== null) {
        agencyParameter = `&agency_id=${state.agency}`
      }
      return `/v1/workers?refresh=${this.refresh}&deleted_at=${this.deleted ? 'true' : 'false'}${agencyParameter}&fields=birth_date,clients,cv,date_last_comment,email,favorite_jobs,first_name,id,last_comment,last_name,mobile_phone_number,postal_city,postal_code,profile_picture,sms_history,state,status,status_updated_at,transportation_means,last_availability,active_proposal`
    },
    // Computed properties for unified availability dialog
    availabilityDialogWorkers(): string[] | number | null {
      // Make this property depend on showAvailabilityDialog to force recalculation
      if (!this.showAvailabilityDialog) return [];

      if (this.availabilityDialogMode === 'single' && this.unitaryWorkerId) {
        return [String(this.unitaryWorkerId)];
      } else {
        return this.selected;
      }
    },
    availabilityDialogData(): any[] {
      // Make this property depend on showAvailabilityDialog to force recalculation
      if (!this.showAvailabilityDialog) return [];

      if (this.availabilityDialogMode === 'single' && this.unitaryWorkerId) {
        return this.getSelectedWorkersData(this.unitaryWorkerId);
      } else {
        return this.getSelectedWorkersData();
      }
    }
  },
  watch: {
    showAvailabilityDialog(newValue) {
      if (newValue) {
        // Force re-evaluation of computed properties by making a temporary change
        // This ensures that the data sent to the dialog is up to date
        const originalMode = this.availabilityDialogMode;
        this.$nextTick(() => {
          // Toggle the mode and then set it back to force the computed properties to update
          this.availabilityDialogMode = this.availabilityDialogMode === 'bulk' ? 'single' : 'bulk';
          this.$nextTick(() => {
            this.availabilityDialogMode = originalMode;
          });
        });
      }
    }
  },
  methods: {
    redirectToSplit(id: number) {
      (this.$refs.list as InstanceType<typeof ListParagon>).redirectToSplitPane(id)
    },
    redirectTo(name: string): void {
      EventBus.$emit("availabilityWorker", name)
    },
    openData(titleModal: string, data: any) {
      this.dialog = true
      this.data = data
      this.titleModal = titleModal
    },
    getNbSelected(n: string[]) {
      this.selected = n
      if (this.selected.length > 1) {
        this.workerTranslation = 'workers'
      } else {
        this.workerTranslation = 'worker'
      }
    },
    showAvailability(workerId: number, data: Availability) {
      this.currentWorkerId = workerId
      this.currentAvailability = { ...data } // Create a copy to avoid modifying the original data

      // Only format dates if they're not already formatted and remove the seconds
      if (this.currentAvailability.date_begin && !this.currentAvailability.date_begin.includes('/')) {
        this.currentAvailability.date_begin = this.localizeDate(this.currentAvailability.date_begin, true)
        this.currentAvailability.date_begin = this.currentAvailability.date_begin.substring(0, this.currentAvailability.date_begin.length-3)
      }

      if (this.currentAvailability.date_end && !this.currentAvailability.date_end.includes('/')) {
        this.currentAvailability.date_end = this.localizeDate(this.currentAvailability.date_end, true)
        this.currentAvailability.date_end = this.currentAvailability.date_end.substring(0, this.currentAvailability.date_end.length-3)
      }

      this.dialogAvailability = true
    },
    refreshList() {
      // Trigger reload of the list data
      EventBus.$emit('listParagonDataReload')
            // If this is a refresh after an archive/reactivate operation, reset selection
      if (['archive', 'reactivate'].includes(this.modalName)) {
        // empty selection
        (this.$refs.list as InstanceType<typeof ListParagon>).emptySelection()
        // trigger a refresh of the list
        this.$emit('update:refresh', this.refresh + 1)
      }
    },
    isImage(url: string): boolean {
      return this.imageTypes[url] || false
    },
    getSelectedWorkersData(workerId?: number | null) {
      // Force refresh of list items if needed
      const listComponent = this.$refs.list as InstanceType<typeof ListParagon>;

      // Access items from the ListParagon component
      const listData = listComponent.items || [];

      // If an id was provided, we only return the data for that worker
      if (workerId) {
        return listData.filter(worker => worker.id === workerId);
      }

      // Filter to only include selected workers
      return listData.filter(worker =>
        this.selected.includes(worker.id.toString())
      );
    },
    // Update the method that opens the bulk update availability dialog
    showBulkUpdateAvailability() {
      this.availabilityDialogMode = 'bulk';

      // Set dialog to true immediately rather than waiting for nextTick
      this.showAvailabilityDialog = true;
    },

    // Update the method that opens the single worker update availability dialog
    showSingleWorkerUpdateAvailability(workerId: number) {
      this.unitaryWorkerId = workerId;
      this.availabilityDialogMode = 'single';

      // Set dialog to true immediately rather than waiting for nextTick
      this.showAvailabilityDialog = true;
    },
  },
  directives: {
    'auth-pdf': authPdfDirective as {
      bind: (el: HTMLElement, binding: DirectiveBinding) => void;
    }
  },
})

